export const LELANG_KIRIM_BALIK = {
  INTENTION_STATUS: {
    PEMBAYARAN: 1,
    WRITE_OFF: 2,
  },
  LOCATION_TYPE: {
    DI_SM: 1,
    DI_CABANG: 2,
  },
}
